<template>
  <form
    ref="form"
    data-url="/evaluator/evaluationPlan/report"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>Resumen General de la Evaluación</h5>
      </legend>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <app-input
            type="textarea"
            v-model="inputs.general_summary"
            :required="true"
            placeholder=""
          />
        </div>
      </div>
    </div>

    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>Impresiones Generales del Equipo Evaluador</h5>
      </legend>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label
            >COMENTARIOS SOBRE LA EFICIENCIA Y ADECUACIÓN DEL SISTEMA DE
            GESTIÓN</label
          >
          <app-input
            type="textarea"
            v-model="inputs.feedback_efficiency_adequacy"
            :required="true"
            placeholder=""
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>FORTALEZAS</label>
          <app-input
            type="textarea"
            v-model="inputs.strengths"
            :required="true"
            placeholder=""
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>ÁREAS CON OPORTUNIDADES DE MEJORA</label>
          <app-input
            type="textarea"
            v-model="inputs.areas_improvement_opportunities"
            :required="true"
            placeholder=""
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label
            >CUMPLIMIENTO CON LOS REQUISITOS DE LA AUTORIDAD REGULADORA</label
          >
          <app-input
            type="textarea"
            v-model="inputs.compliance_requirements_1"
            :required="true"
            placeholder=""
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label
            >CUMPLIMIENTO CON LOS REQUISITOS DE USO DEL SÍMBOLO DE ACREDITACIÓN
            Y REFERENCIA A LA CONDICIÓN DE ACREDITADO (SAE CR GA04)</label
          >
          <app-input
            type="textarea"
            v-model="inputs.compliance_requirements_2"
            :required="true"
            placeholder=""
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label
            >CONTROL DE LA EFICIENCIA DE LAS ACCIONES CORRECTIVAS Y TRATAMIENTO
            DE COMENTARIOS DE LA ÚLTIMA EVALUACIÓN (VERIFICAR INFORMACIÓN
            CONTENIDA EN INFORME DE ACCIONES CORRECTIVAS PRESENTADAS POR EL
            OEC)</label
          >
          <app-input
            type="textarea"
            v-model="inputs.efficiency_control"
            :required="true"
            placeholder=""
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>CAMBIOS PRINCIPALES DE LA ÚLTIMA EVALUACIÓN</label>
          <app-input
            type="textarea"
            v-model="inputs.main_changes_last_evaluation"
            :required="true"
            placeholder=""
          />
        </div>
      </div>
    </div>

    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>Localizaciones Críticas</h5>
      </legend>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label
            >EVIDENCIA RECABADA E INFORMACIÓN ANALIZADA RESPECTO A ACTIVIDADES
            DE LOCALIZACIONES QUE PODRÍAN SER CRÍTICAS</label
          >
          <app-input
            type="textarea"
            v-model="inputs.collected_evidence"
            :required="true"
            placeholder=""
          />
        </div>
      </div>
    </div>

    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>Testificaciones</h5>
      </legend>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label
            >REVISIÓN DE TESTIFICACIONES PENDIENTES Y COORDINACIÓN DE LAS MISMAS
            EN CASO DE SER NECESARIO</label
          >
          <app-input
            type="textarea"
            v-model="inputs.testimony_review"
            :required="true"
            placeholder=""
          />
        </div>
      </div>
    </div>

    <div class="mt-5">
      <button
        type="submit"
        class="btn btn-primary mr-2"
        @click.prevent="submit"
      >
        {{ $t("save") }}
      </button>
    </div>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {
        general_summary: "",
        feedback_efficiency_adequacy: "",
        strengths: "",
        areas_improvement_opportunities: "",
        compliance_requirements_1: "",
        compliance_requirements_2: "",
        efficiency_control: "",
        main_changes_last_evaluation: "",
        collected_evidence: "",
        testimony_review: "",
      },
    };
  },
  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest != null
        ? this.$store.state.evaluatorReview.evalTest
        : { code: "" };
    },
  },
  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },
  created() {
    this.loadForm();
    this.data();
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      this.$store.state.evaluatorReview.evalTest = res.data.data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {},

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest != null) {
        this.inputs.id = this.$store.state.evaluatorReview.evalTestId;
        this.inputs.general_summary = this.$store.state.evaluatorReview.evalTest.general_summary;
        this.inputs.feedback_efficiency_adequacy = this.$store.state.evaluatorReview.evalTest.feedback_efficiency_adequacy;
        this.inputs.strengths = this.$store.state.evaluatorReview.evalTest.strengths;
        this.inputs.areas_improvement_opportunities = this.$store.state.evaluatorReview.evalTest.areas_improvement_opportunities;
        this.inputs.compliance_requirements_1 = this.$store.state.evaluatorReview.evalTest.compliance_requirements_1;
        this.inputs.compliance_requirements_2 = this.$store.state.evaluatorReview.evalTest.compliance_requirements_2;
        this.inputs.efficiency_control = this.$store.state.evaluatorReview.evalTest.efficiency_control;
        this.inputs.main_changes_last_evaluation = this.$store.state.evaluatorReview.evalTest.main_changes_last_evaluation;
        this.inputs.collected_evidence = this.$store.state.evaluatorReview.evalTest.collected_evidence;
        this.inputs.testimony_review = this.$store.state.evaluatorReview.evalTest.testimony_review;
      }
    },
  },
};
</script>
